import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiAvatar from '@material-ui/core/Avatar';

const useStyles = (size, primary, backgroundColor) => makeStyles((theme) => {
  let root = {};
  if (size) {
    root = {
      ...root,
      width: size,
      height: size,
      '& svg': {
        width: size * 0.6,
        height: size * 0.6,
      },
      fontSize: size * 0.5,
    };
  }
  if (primary) {
    root = {
      ...root,
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    };
  } else if (backgroundColor) {
    root = {
      ...root,
      backgroundColor,
    };
  }
  return { root };
});

const Avatar = ({
  size, primary, backgroundColor, variant, style, children, onClick,
}) => {
  const classes = useStyles(size, primary, backgroundColor)();

  const avatarProps = { variant, style, onClick };

  return (
    <MuiAvatar className={classes.root} {...avatarProps}>
      { children }
    </MuiAvatar>
  );
};

Avatar.propTypes = {
  size: PropTypes.number,
  primary: PropTypes.bool,
  backgroundColor: PropTypes.string,
  variant: PropTypes.oneOf(['circle', 'rounded', 'square']),
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

Avatar.defaultProps = {
  size: null,
  primary: false,
  backgroundColor: null,
  variant: 'circle',
  style: null,
  onClick: null,
};

export default React.memo(Avatar);



// WEBPACK FOOTER //
// ./components/core/Avatar.js